import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const CheckSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 14 12",
  color = "#ccc",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M13.017 2.618L6.011 9.625a1.075 1.075 0 01-1.525 0L.983 6.122a1.077 1.077 0 111.524-1.525L5.248 7.34l6.245-6.245a1.077 1.077 0 111.524 1.524z"
        fill={color}
      />
    </svg>
  );
};

export { CheckSvg };
